
import { FormEventType } from './enums';
import FormErrorMessage from './form-error-message';
import { GutterProperty } from '../gutter/enums';
import { StylePositionType, StyleSizeType } from '../../styles/enums';
import Gutter from '../gutter';

export default {
  name: 'FormGroup',
  components: {
    FormErrorMessage,
    Gutter,
  },
  props: {
    formGroup: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      GutterProperty,
      StylePositionType,
      StyleSizeType,
    };
  },
  computed: {
    value() {
      return this.formGroup.value;
    },
    errors() {
      return this.formGroup.errors;
    },
    formError() {
      return this.formGroup.error;
    },
    isValid() {
      return this.formGroup.isValid;
    },
  },
  watch: {
    value(formValue) {
      this.handleChange(formValue);
    },
  },
  methods: {
    getControl(name) {
      return this.formGroup.getControl(name);
    },
    handleChange(value) {
      this.$emit(FormEventType.Change, value);
    },
    handleSubmit(event) {
      event.preventDefault();

      this.$emit(FormEventType.Submit, this.value);
    },
  },
};
